// closeModalAfterSeconds.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import removeModals from '../action/removeModals.js';
import getOperationData from '../selector/getOperationData.js';

/**
 * Close modal after seconds
 * @kind action
 * @param {string} {modalId} - modal id.
 * @param {number} {seconds} - timeout seconds.
 * @return {Promise} Action promise.
 */
const closeModalAfterSeconds =
  ({ modalId, seconds }) =>
  async (dispatch, getState) => {
    const existedTimerId = getOperationData(getState(), ['timer'], modalId);
    if (existedTimerId) {
      clearTimeout(existedTimerId);
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['timer', 'modal'],
          data: {
            [modalId]: null,
          },
        },
      });
    }
    const timerId = setTimeout(() => {
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['timer', 'modal'],
          data: {
            [modalId]: null,
          },
        },
      });
      dispatch(
        removeModals({
          ids: [modalId],
          transitionStatus: 'closing',
        })
      );
    }, seconds * 1000);
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['timer', 'modal'],
        data: {
          [modalId]: timerId,
        },
      },
    });
  };

export default closeModalAfterSeconds;
